import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const About = () => {
    // Animation Variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { duration: 0.8, staggerChildren: 0.2 } }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
    };

    return (
        <section id="about" className="py-24 bg-white overflow-hidden">
            <motion.div
                className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center"
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
            >
                {/* Left Side: Image + Experience Box */}
                <motion.div className="relative" variants={itemVariants}>
                    <img
                        src="/office-team.jpg"
                        alt="Raj Kuruma Team"
                        className="rounded-2xl shadow-2xl w-full h-[300px] sm:h-[450px] md:h-[600px] object-cover"
                    />
                    <motion.div
                        className="absolute -bottom-12 -right-5 md:-right-12 bg-[#f15a24] text-white p-10 rounded-2xl shadow-2xl w-72"
                        whileHover={{ scale: 1.05 }}
                    >
                        <h2 className="text-6xl font-extrabold mb-2">20+</h2>
                        <p className="font-bold text-xl">Years Working Experience</p>
                        <div className="mt-3 text-white font-mono text-2xl">~~~~~</div>
                    </motion.div>
                </motion.div>

                {/* Right Side: Content */}
                <motion.div variants={itemVariants}>
                    <h4 className="text-[#f30a40] font-black tracking-[0.3em] uppercase text-lg mb-4">
                        About Us
                    </h4>

                    <h2 className="text-5xl md:text-6xl font-extrabold text-gray-900 mb-8 leading-tight">
                        Trusted Business & Mobility Solutions Since 2005
                    </h2>

                    <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                        Raj Kuruma Enterprises Pvt. Ltd. is a professional service provider offering reliable
                        <strong className="text-gray-900"> car rental, property leasing, and business setup solutions across India.</strong>
                    </p>

                    <div className="space-y-6 mb-10">
                        {['Car Rental Services', 'Pan-India Service Coverage', 'Customer-Focused Approach'].map((text, i) => (
                            <motion.div key={i} className="flex items-center text-gray-900 font-bold text-lg" variants={itemVariants}>
                                <span className="text-[#f15a24] mr-4 text-xl">✔</span> {text}
                            </motion.div>
                        ))}
                    </div>

                    {/* Stats Section */}
                    <div className="flex flex-col md:flex-row gap-10 items-center border-t border-gray-200 pt-10">
                        <div className="flex items-center gap-5">
                            <div className="text-5xl">💬</div>
                            <div>
                                <p className="text-sm font-bold text-gray-500 uppercase">Emergency</p>
                                <p className="text-2xl font-black text-gray-900">9999320112</p>
                            </div>
                        </div>
                        <div className="flex gap-10 border-l border-gray-200 pl-10">
                            <motion.div whileHover={{ y: -5 }}>
                                <h3 className="text-4xl font-black text-[#f15a24]">100%</h3>
                                <p className="text-md font-bold text-gray-600">Success Rate</p>
                            </motion.div>
                            <motion.div whileHover={{ y: -5 }}>
                                <h3 className="text-4xl font-black text-[#f15a24]">2,563+</h3>
                                <p className="text-md font-bold text-gray-600">Satisfied Clients</p>
                            </motion.div>
                        </div>
                    </div>

                    <motion.div
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <Link
                            to="/about"
                            className="mt-12 bg-gray-900 text-white px-12 py-5 font-black text-lg hover:bg-[#f15a24] transition duration-300 inline-block"
                        >
                            ABOUT MORE →
                        </Link>
                    </motion.div>
                </motion.div>
            </motion.div>
        </section>
    );
};

export default About;